module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Media-d3fbffbb2d953c59bfc7869bbe33da91.svg";